<template>
    <div class="ie right-col u-full-height--passport u-d-block"
         :class="{ 'p-homepage': isHomePage,'right-col--collapse-menu': isMenuCollapsed }">
        <icons></icons>
        <router-view></router-view>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import dropdown from 'components/dropdown/Dropdown.vue';
    import Icons from 'components/Icons.vue';
    import CreateANewClaim from 'components/dropdown/CreateANewClaim';
    import HeaderSection from 'components/Header.vue';

    export default {
        name: 'right-col',
        components: {
            dropdown,
            Icons,
            CreateANewClaim,
            HeaderSection
        },
        computed: {
            ...mapGetters('menu', ['isMenuOpen', 'isMobileMenuOpen', 'isMenuCollapsed']),
            ...mapGetters('windowWidth', ['theCurrentWidth']),
            isHomePage() {
                return this.$route.fullPath === '/';
            },
            showHeader() {
                let allowForPath = [
                    // Paths where it is removed
                    'mini-calculators',
                    'executive-dashboard',
                    'reserving',
                    'support',
                    'discount-rate-comparison',
                    'compare'
                    // Check is we on that path, all should be false
                ].map(this.isInRoutePath.bind(this)).every(isRoute => !isRoute);

                return this.theCurrentWidth < 1024 || allowForPath
            }
        },
        watch: {
            '$route'() {
                window.scrollTo(0, 0);
            }
        },
        methods: {
            ...mapActions('dropdown', ['toggle']),
            ...mapActions('menu', ['updateMenu', 'updateMobileMenu', 'updateSubMenu']),
            ...mapActions('fatal', {resetFatal: 'reset'}),
            ...mapActions('claim', ['reset', 'initialise']),
            ...mapActions('fatal/interimPayments', {resetInterimPayments: 'reset'}),
            isRoute(route) {
                return !!this.$route.matched.filter(function (matched) {
                    return matched && (matched.path.indexOf(route) !== -1 || matched.name === route);
                }).length;
            },
            isInRoutePath(routeName) {
                return ~this.$route.path.indexOf(routeName)
            },
            force() {
                this.forceMenu = true;
            }
        },
    }
</script>



// WEBPACK FOOTER //
// RightCol.vue?b2939c6c